import { render, staticRenderFns } from "./individual_answer_result.vue?vue&type=template&id=b6a57242&"
import script from "./individual_answer_result.vue?vue&type=script&lang=js&"
export * from "./individual_answer_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports